/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets SDUAUserInformation from api:
 * /v1/ua/sd_user_info
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdUserInfoUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/ua/sd_user_info`, models.SDUAUserInformation);
};

/**
 * Gets SDUAUserLocalOfficeAddress from api:
 * /v1/ua/sd_user_local_office_address
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdUserLocalOfficeAddressUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_user_local_office_address`,
    models.SDUAUserLocalOfficeAddress
  );
};

export { fetchSdUserInfoUtil, fetchSdUserLocalOfficeAddressUtil };
